<template>
  <div>
    <filters
      :defaults="filterDefaults"
      @updateDateFrom="updateFilterData('dateFrom', $event)"
      @updateDateTo="updateFilterData('dateTo', $event)"
      @updateSelectedHighway="updateFilterData('highwayId', $event)"
    />

    <catalog-table
      title="Comparativa presupuestado vs realmente utilizado"
      id="budget-quantification"
      ref="reportTable"
      :table-data="sinisters"
      :table-headers="sinistersHeaders"
      :pagination-info="paginationInfo"
      :loading="loading"
      search-placeholder="Buscar por Nombre o Código"
      @updatedSearchQuery="filterData.searchQuery = $event"
      @pageUpdated="paginationParams.currentPage = $event"
      @updatedPageSize="paginationParams.currentPageSize = $event"
    >
      <sinister-detail
        slot="sinister-cell"
        slot-scope="{ item, value }"
        :sinister_number="value"
        :sinister_id="item.sinister_id"
      />
      <double-columns
        slot="sinisterScope-cell"
        slot-scope="{ item, value }"
        :firstAmmount="value.expectedScope"
        :secondAmmount="value.realScope"
      />
      <double-columns
        slot="sinisterMasters-cell"
        slot-scope="{ item, value }"
        :firstAmmount="value.expectedMasters"
        :secondAmmount="value.realMasters"
      />
      <double-columns
        slot="sinisterOfficials-cell"
        slot-scope="{ item, value }"
        :firstAmmount="value.expectedOfficials"
        :secondAmmount="value.realOfficials"
      />
      <double-columns
        slot="sinisterAssistants-cell"
        slot-scope="{ item, value }"
        :firstAmmount="value.expectedAssistant"
        :secondAmmount="value.realAssistant"
      />
      <double-columns
        slot="sinisterFlagers-cell"
        slot-scope="{ item, value }"
        :firstAmmount="value.expectedFlag"
        :secondAmmount="value.realFlag"
      />
    </catalog-table>
  </div>
</template>

<script>
import Filters from "./Filter";
import { CatalogTable } from "@/components/";
import budgetService from "@/services/reports/budgetReport/budgetService";
import doubleColumns from "./DoubleColumns";
import sinisterDetail from "./SinisterDetail";
import { debounce } from "lodash";

export default {
  name: "Validation",

  props: {
    dateFilter: {
      type: String,
      default: "assignationDate",
    },

    filterDefaults: {
      type: Object,
      default: () => ({}),
    },

    showTableActions: {
      type: Boolean,
      default: true,
    },
  },

  components: {
    Filters,
    CatalogTable,
    doubleColumns,
    sinisterDetail,
  },

  data() {
    return {
      sinisters: [],
      sinistersHeaders: {
        sinister: "Número de siniestro",
        sinisterScope: "Dias estimados/reales",
        sinisterMasters: "Maestros solicitados/utilizados",
        sinisterOfficials: "Oficiales solicitados/utilizados",
        sinisterAssistants: "Asistentes solicitados/utilizados",
        sinisterFlagers: "Bandereros solicitados/utilizados",
      },
      filterData: {
        dateFrom: null,
        dateTo: null,
        highwayId: null,
        searchQuery: null,
      },
      sinistersFilters: {
        sinNumber: null,
      },
      paginationParams: {
        currentPage: 1,
        currentPageSize: 10,
      },
      searchQuery: null,
      paginationInfo: null,
    };
  },

  created() {
    this.fetchSinisters();
  },

  computed: {
    fetchParams() {
      const filtersParams = this.filtersParams;
      const searchQuery = this.filterData.searchQuery;

      return { ...filtersParams, searchQuery };
    },
    filtersParams() {
      const page = this.paginationParams.currentPage;
      const pageSize = this.paginationParams.currentPageSize;
      const from = this.filterData.dateFrom;
      const to = this.filterData.dateTo;
      const highway = this.filterData.highwayId;
      return { page, pageSize, from, to, highway };
    },
  },

  methods: {
    fetchSinisters() {
      this.loading = true;
      this.sinisters = [];
      return budgetService(this.fetchParams)
        .then(({ sinisters, paginationInfo }) => {
          this.sinisters = sinisters;
          this.paginationInfo = paginationInfo;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    updateFilterData(item, value) {
      this.currentPage = 1;
      this.filterData[item] = value;
    },
  },

  watch: {
    "filterData.searchQuery": debounce(function () {
      this.currentPage = 1;
      this.fetchSinisters().then(() => {
        this.$refs.reportTable.focusSearch();
      });
    }, 500),
    filtersParams: debounce(function () {
      this.fetchSinisters();
    }, 100),
    "paginationInfo.previous": function (value) {
      this.currentPage = (value || 0) + 1;
    },
    currentPageSize() {
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="css" scoped>
#budget-quantification .md-table-cell:nth-child(1),
#budget-quantification .md-table-head:nth-child(1) {
  width: 45%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Reports/BudgetReport/index.vue